<template>
  <MtxCard v-if="commits.length" class="my-rewards mt-3">
    <h4 class="text-center">Commits With Available Rewards</h4>
    <p>
      Here you will see commits that you have a reward available to withdraw. These can either be
      your own commits, or descendents of commits you have created.
    </p>
    <ul class="list-plain mt-4">
      <li
        v-for="commit of commits"
        :key="commit.hash"
        class="grid column-gap align-center my-rewards__reward mt-2"
      >
        <div class="my-rewards__commit-hash">
          <RouterLink :to="`/commits/${commit.hash}`">
            {{ commit.hash }}
          </RouterLink>
        </div>
        <button @click="requireWeb3(withdraw(commit.hash))" class="btn--block">
          Withdraw {{ commit.reward | mtx }}
        </button>
      </li>
    </ul>
  </MtxCard>
</template>

<script>
import web3 from "@/mixins/web3"
import API from "@/api"

export default {
  mixins: [web3],

  data: () => ({
    commits: []
  }),

  watch: {
    "$store.state.user.ethAddress": {
      async handler(account) {
        this.commits = []
        const { data, success } = await API.getCommitRewards(account)

        if (success) {
          this.commits = await this.getRewards(data.hashes)
        }
      },
      immediate: true
    }
  },

  methods: {
    async getRewards(hashes) {
      if (!hashes.length) return []

      const Commit = await this.contracts.Commit

      const rewards = await Promise.all(
        hashes.map(async hash => {
          const reward = await Commit.getAvailableRewardForUser(
            hash,
            this.$store.state.user.ethAddress
          )
          return { hash, reward }
        })
      )

      return rewards.filter(({ reward }) => reward > 0)
    },

    async withdraw(hash) {
      const Commit = await this.contracts.Commit

      const tx = this.addPlannedTx({
        txFn: () => Commit.withdrawAvailableReward(hash),
        header: "Withdraw Reward",
        body: "This transfer your available reward on this commit to your account."
      })

      tx.then(() => {
        const idx = this.commits.findIndex(commit => commit.hash === hash)
        this.commits.splice(idx, 1)
      })
    }
  }
}
</script>

<style lang="scss">
.my-rewards {
  &__reward {
    grid-template-columns: 1fr auto;
    grid-row-gap: $size1;
  }

  &__commit-hash {
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
</style>
